export class Matieres {
     pointConfidentielParDefaut:boolean = false;
     description:string;
     utilisable:boolean = true;
     profilUtilisationId:number = 0;
     profilVisualisationId:number = 0;
     tri:string;
     id:number;
     public echevinats:Array<number> = [];
     constructor(data:any) {
         Object.assign(this, data);
     }
}
 